//@ts-nocheck
import dateFns from 'date-fns';
import addMonths from 'date-fns/add_months';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import pick from 'lodash/pick';
import debounce from 'lodash/debounce';
import findIndex from 'lodash/findIndex';
import { apiData, getNewsData, getRobotData } from './dataService';
import customFilter from '../filter/index';
import htmlOptions from '../../config/html';
import {
  locationMap,
  mapChinese,
  b2bMap,
  industryMap,
  semMap,
  capitalMap,
  enttypeList,
  enttypeMap,
  entStatusList,
  entstatusMap,
  topHandleOffSetMap,
  industrySubMap
} from './optionMap';
import config from '../config';
import {
  setItem,
  getItem,
  removeItem,
  objToLabels,
  getStrLen,
  filterCapital,
  filterEstablishDate,
  RegistCall,
  getOrigin,
  eventHub,
  showOperateMessage,
  getPublicName
} from './utils';
import gemLink from '../components/global/gemLink.vue';
import editMeal from '../components/global/editMeal.vue';
import mealEditor from '../components/global/mealEditor.vue';
import mealtabs from '../components/global/mealtabs.vue';
import searchSelect from '../components/clickSelect/searchSelect.vue';
import themeSelect from '../components/clickSelect/themeSelect.vue';
import searchableSelect from '../components/search/searchTable/select.vue';
import ClickSelect from '../components/clickSelect/index.vue';
import Captital from '../components/clickSelect/capital.vue';
import Establish from '../components/clickSelect/establish.vue';
import colorChoose from '../components/clickSelect/colorChoose.vue';
import Industry from '../components/clickSelect/industry.vue';
import Region from '../components/clickSelect/region.vue';
import Sort from '../components/global/sort.vue';
import Phone from '../components/global/phone.vue';
import Tags from '../components/global/tags.vue';
import Labels from '../components/global/labels.vue';
import customPagination from '../components/global/customPagination.vue';
import generalSelect from '../components/clickSelect/generalSelect.vue';
import generalItem from '../components/clickSelect/generalItem.vue';
import awaitTips from '../components/global/awaitTips';
import selectedWrap from '../components/global/selectedWrap.vue';
import inputNumber from 'element-ui/lib/input-number';
import formItem from 'element-ui/lib/form-item';
import { getPropByPath } from 'element-ui/lib/utils/util';
import step from 'element-ui/lib/step';
import { errorCode } from './errorCode';
import installPermission from './installPermission';
inputNumber.methods.handleInputChange = function(value) {
  const newVal = value === '' ? 0 : Number(value);
  if (!isNaN(newVal) || value === '') {
    this.setCurrentValue(newVal);
  }
};
step.methods.calcProgress = function(status) {
  let step = 100;
  const style = {};

  style.transitionDelay = 150 * this.index + 'ms';
  if (status === this.$parent.processStatus) {
    step = this.currentStatus !== 'error' ? 100 : 100;
  } else if (status === 'wait') {
    step = 0;
    style.transitionDelay = -150 * this.index + 'ms';
  }

  style.borderWidth = step ? '1px' : 0;
  this.$parent.direction === 'vertical'
    ? (style.height = step + '%')
    : (style.width = step + '%');

  this.lineStyle = style;
};

formItem.methods.onFieldBlur = function() {
  if (this.fieldValue && typeof this.fieldValue == 'string') {
    /*输入框在验证前添加去除空格操作*/
    const model = this.form.model;
    if (!model || !this.prop) {
      return;
    }
    let path = this.prop;
    if (path.indexOf(':') !== -1) {
      path = path.replace(/:/, '.');
    }
    let key = getPropByPath(model, path, true).k;
    let obj = getPropByPath(model, path, true).o;
    obj[key] = obj[key].trim();
  }
  /*console.log(this.fieldValue);*/
  this.validate('blur');
};

const userStr = getItem('local', 'twe_userInfo');

let ticking = false;
let cbId = null;
export const GemPlugin = {
  install: function(Vue, options) {
    // filters
    Vue.filter('date', function(value, format = 'YYYY-MM-DD', getHourLabel) {
      if (value && value != '0') {
        let date = dateFns.format(parseInt(value), format);
        if (getHourLabel) {
          let config = date.split(':');
          if (config[0] > 12) {
            return ' 下午 ' + date;
          } else {
            return ' 上午 ' + date;
          }
        } else {
          return date;
        }
      } else {
        return '-';
      }
    });

    Vue.filter('zhDate', function(value, format = 'YYYY-MM-DD') {
      if (value && value !== '0') {
        let date = dateFns.format(parseInt(value), format);
        let config = date.split('-');
        return config[0] + '年' + config[1] + '月' + config[2] + '日';
      } else {
        return '-';
      }
    });

    Vue.filter('guard', function(value, append = '') {
      if (!append) {
        append = '';
      }
      if (value) {
        if (typeof value === 'string') {
          if (value === '0' || value === 'NULL' || value === 'null') {
            return '-';
          }
          if (!!value.trim()) {
            return value.trim() + append;
          } else {
            return '-';
          }
        } else {
          return value + append;
        }
      } else {
        return '-';
      }
    });

    Vue.filter('site', function(value, oldVal) {
      if (value) {
        if (value.indexOf('http') == -1) {
          return 'http://' + value;
        } else {
          return value;
        }
      } else {
        return '-';
      }
    });

    Vue.filter('province', function(value) {
      if (value) {
        return locationMap[value];
      } else {
        return '-';
      }
    });

    Vue.filter('b2b', function(value) {
      if (value) {
        return b2bMap[value];
      } else {
        return '-';
      }
    });

    Vue.filter('capital', function(value) {
      return filterCapital(value);
    });

    Vue.filter('establishDate', function(value) {
      return filterEstablishDate(value);
    });

    Vue.filter('sem', function(value) {
      if (value) {
        return semMap[value];
      } else {
        return '-';
      }
    });

    Vue.filter('industry', function(value) {
      if (value) {
        return industryMap[value] || industrySubMap[value];
      } else {
        return '-';
      }
    });

    Vue.filter('hire', function(value) {
      return mapChinese[value];
    });

    Vue.filter('thousands', function(value) {
      if (!isNaN(value) && value != null && value != 0) {
        let s = parseFloat((value + '').replace(/[^\d.-]/g, '')) + '';
        let l = s
          .split('.')[0]
          .split('')
          .reverse();
        let t = '';
        for (let i = 0; i < l.length; i++) {
          t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
        }
        return t
          .split('')
          .reverse()
          .join('');
      } else {
        return '0';
      }
    });

    Vue.filter('secToTime', function(value) {
      if (value) {
        return customFilter.secToTime(value);
      } else {
        return '-';
      }
    });

    //add global method or property
    Vue.validateName = function(value) {
      if (getStrLen(value) > 20) {
        return true;
      } else {
        return false;
      }
    };
    Vue.addScrollObserver = function(elm = window, cb) {
      cbId = function(ev) {
        onScroll(ev, cb);
      };
      elm.addEventListener('scroll', cbId);
    };
    Vue.removeScrollObserver = function() {
      window.removeEventListener('scroll', cbId);
    };
    //directives
    Vue.directive('clear', {
      inserted(el, binding, vnode, oldVnode) {
        el.cb = function(ev) {
          if (vnode.componentInstance.model === binding.value) {
            window.setTimeout(params => {
              vnode.componentInstance.model = '';
            });
          }
        };
        el.addEventListener('click', el.cb);
      },
      unbind(el, binding) {
        el.removeEventListener('click', el.cb);
      }
    });

    Vue.directive('highlight', {
      inserted(el, binding, vnode, oldVnode) {
        const RE = new RegExp('[' + binding.value.keyword + ']', 'g');
        if (binding.value.content) {
          el.innerHTML = binding.value.content.replace(
            RE,
            '<em>' + '$&' + '</em>'
          );
        } else {
          el.innerHTML = '-';
        }
      },
      update(el, binding, vnode, oldVnode) {
        const RE = new RegExp('[' + binding.value.keyword + ']', 'g');
        if (binding.value.content) {
          el.innerHTML = binding.value.content.replace(
            RE,
            '<em>' + '$&' + '</em>'
          );
        } else {
          el.innerHTML = '-';
        }
      }
    });
    Vue.directive('hide', {
      bind(el, binding) {
        el.style.opacity = binding.value ? '0' : '1';
      },
      update(el, binding) {
        el.style.opacity = binding.value ? '0' : '1';
      }
    });

    //instance methods
    if (userStr) {
      installPermission(Vue, JSON.parse(userStr));
    }
    Vue.prototype.sleep = function(millesecond) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, millesecond);
      });
    };
    Vue.prototype.addMonth = function(date, amount) {
      return addMonths(date, amount).getTime();
    };
    Vue.prototype.HQ = __VERSION === 'HQ';
    Vue.prototype.KJN =
      __VERSION === 'kjn_sandbox' ||
      __VERSION === 'kjn_online' ||
      __VERSION === 'kjn_stage';
    Vue.prototype.apiData = apiData;
    Vue.prototype.getNewsData = getNewsData;
    Vue.prototype.getRobotData = getRobotData;
    Vue.prototype.cloneDeep = cloneDeep;
    Vue.prototype.filter = filter;
    Vue.prototype.errorCode = errorCode;
    Vue.prototype.pick = pick;
    Vue.prototype.debounce = debounce;
    Vue.prototype.findIndex = findIndex;
    Vue.prototype.setItem = setItem;
    Vue.prototype.getItem = getItem;
    Vue.prototype.removeItem = removeItem;
    Vue.prototype.objToLabels = objToLabels;
    Vue.prototype.enttypeList = enttypeList;
    Vue.prototype.enttypeMap = enttypeMap;
    Vue.prototype.entStatusList = entStatusList;
    Vue.prototype.entstatusMap = entstatusMap;
    Vue.prototype.validateName = function(value) {
      if (getStrLen(value) > 20) {
        return true;
      } else {
        return false;
      }
    };
    /* 红圈跳转至营销报告start */
    Vue.prototype.hrefJump = function(href, companyName) {
      if (__VERSION === 'HQ') {
        let target = `${
          htmlOptions[__HTMlVERSION].REDIRECT_URL
        }?url=${encodeURIComponent(getOrigin() + href)}&title=红圈线索`;
        // console.log(target)
        parent.postMessage({ msg: target }, '*');
      } else {
        window.open(getOrigin() + href, '_blank');
      }
    };
    /* end */
    Vue.prototype.getTaskNum = function(data) {
      let value = parseInt(data);
      if (value <= 100 && value > 0) {
        return [value];
      }
      if (value > 100) {
        let taskNum = [];
        let num = parseInt(value / 100);
        let num2 = value % 100;
        for (let i = 1; i <= num; i++) {
          taskNum.push(i * 100);
        }
        if (num2 != 0) {
          taskNum.push(value);
        }
        return taskNum;
      }
      return 0;
    };
    Vue.prototype.checkTaskNum = function(val, maxNum) {
      let reg = /^(?:[1-9]\d{0,3}|0|50000|[1-4]\d{4})$/;
      if (!reg.test(val) || val > maxNum) {
        return false;
      } else {
        return true;
      }
    };
    Vue.prototype.checkEntstatus = function(value) {
      if (
        value.indexOf('吊销') != -1 ||
        value.indexOf('注销') != -1 ||
        value.indexOf('停业') != -1 ||
        value.indexOf('撤销') != -1
      ) {
        return true;
      } else {
        return false;
      }
    };
    Vue.prototype.validateEmail = function(value) {
      const emailRE = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      return emailRE.test(value);
    };
    Vue.prototype.validatePhone = function(value) {
      const phoneRE = /^1\d{10}$/;
      return phoneRE.test(value);
    };
    Vue.prototype.RegistCall = RegistCall;
    Vue.prototype.getOrigin = getOrigin;
    Vue.prototype.addTrailNote = function(pid, cid) {
      try {
        apiData(
          'post',
          'clue/addTrailNote',
          {
            pid: pid,
            cid: cid,
            action: 2
          },
          '',
          true
        ).then(resp => {
          if (resp.success) {
            eventHub.$emit('refreshTrailNoteList', 1);
          }
        });
      } catch (error) {
        console.log(error);
      }
    };
    Vue.prototype.getOperateStatus = function(section, gonghaiName, pluginId) {
      try {
        let data = {
          section: section
        };
        if (gonghaiName) {
          data.gonghaiName = gonghaiName;
        }
        if (pluginId) {
          data.pluginId = pluginId;
        }
        let result = apiData('get', 'user/getOperateLimitInfo', data);
        return result;
      } catch (error) {
        return error;
      }
    };
    Vue.prototype.goTop = function() {
      window.scrollTo(0, 0);
    };
    Vue.prototype.checkTopHandleFixed = function(from, flag) {
      let scrollHeight =
        document.body.scrollTop == 0
          ? document.documentElement.scrollTop
          : document.body.scrollTop;
      let topMenuHeight = 60;
      let broadHeight = flag ? 38 : 0;
      let handleOffSetHeight = topHandleOffSetMap[from];
      return scrollHeight >= handleOffSetHeight - broadHeight - topMenuHeight;
    };
    Vue.prototype.getUuid = function uuid() {
      let s = [];
      let hexDigits = '0123456789abcdef';
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      let Uuid = s.join('');
      return Uuid;
    };
    Vue.prototype.filterChecks = function(value, title, userid) {
      for (var key in value) {
        let tip = '';
        switch (key) {
          case 'contact': {
            tip = value[key] != '0' ? '联系方式' : '';
            break;
          }
          case 'entstatus': {
            tip = value[key] != '0' ? '营业状态' : '';
            break;
          }
          case 'enttype': {
            tip = value[key] != '0' ? '企业类型' : '';
            break;
          }
          case 'registercapital': {
            tip = value[key] != '0' ? '注册资本' : '';
            break;
          }
          case 'establishment': {
            tip = value[key] != '0' ? '成立年限' : '';
            break;
          }
          case 'industryshort': {
            tip = value[key].length > 0 ? '所属行业' : '';
            break;
          }
          case 'location': {
            tip = value[key].length > 0 ? '所在地区' : '';
            break;
          }
        }
        if (tip) {
          window._hmt.push(['_trackEvent', '用户', title + '-' + tip, userid]);
        }
      }
    };
    Vue.prototype.checkHistoryName = function(inputName) {
      let historyNames = inputName.split(',');
      let historyNameList = [];
      let temp = [];
      if (historyNames.length > 1) {
        historyNames.forEach((item, i) => {
          item = item.trim();
          if (temp.indexOf(item) == -1) {
            temp.push(item);
            historyNameList.push(
              item + '<span class="historyNameTip">曾用名</span>'
            );
          }
        });
      } else {
        historyNameList.push(
          inputName + '<span class="historyNameTip">曾用名</span>'
        );
      }
      return historyNameList;
    };

    Vue.prototype.filterKeyWord = function(value) {
      let show;
      value = value.replace(/\s*/g, '');
      const unique1 = arr => new Set(arr);
      let uniqueArr = Array.from(unique1(value));
      if (uniqueArr.indexOf('有') !== -1) {
        uniqueArr.splice(uniqueArr.indexOf('有'), 1);
      }
      if (uniqueArr.indexOf('限') !== -1) {
        uniqueArr.splice(uniqueArr.indexOf('限'), 1);
      }
      if (uniqueArr.indexOf('公') !== -1) {
        uniqueArr.splice(uniqueArr.indexOf('公'), 1);
      }
      if (uniqueArr.indexOf('司') !== -1) {
        uniqueArr.splice(uniqueArr.indexOf('司'), 1);
      }
      if (uniqueArr.length == 0) {
        // return this.$message.error("搜索词太宽泛了，请输入更精确的关键词重试");
        return false;
      } else {
        return true;
      }
    };

    // 动态年报选项
    Vue.prototype.getReportTime = function(value, format = 'YYYY') {
      let now = new Date();
      let nowYear = now.getFullYear();
      // // 动态显示最近5年的年报，每年的06月01日后才显示上一年的年报
      let divideDate = new Date(nowYear + '-6-1 00:00:00').getTime();
      let reportYearMin = nowYear - 5;
      let reportYearMax = nowYear - 1;
      if (now.getTime() < divideDate) {
        reportYearMin--;
        reportYearMax--;
      }
      let middleYear = 2014, //reportYearMin,
        id = 123,
        YearArr = [];
      for (middleYear; middleYear <= reportYearMax; middleYear++) {
        let currentItem = {
          id: id,
          nameCn: middleYear + '年年报',
          name: ''
        };
        YearArr.unshift(currentItem);
        // middleYear++;
        id++;
      }
      // console.log(YearArr,reportYearMin,reportYearMax,{reportYearMin, reportYearMax})
      return YearArr; //{reportYearMin, reportYearMax};
    };

    Vue.prototype.showOperateMessage = showOperateMessage;

    Vue.prototype.getPublicName = getPublicName;

    //component
    Vue.component('gemLink', gemLink);
    Vue.component('searchSelect', searchSelect);
    Vue.component('themeSelect', themeSelect);
    Vue.component('searchableSelect', searchableSelect);
    Vue.component(editMeal.name, editMeal);
    Vue.component(mealEditor.name, mealEditor);
    Vue.component(mealtabs.name, mealtabs);
    Vue.component('capital', Captital);
    Vue.component('establish', Establish);
    Vue.component('colorChoose', colorChoose);
    Vue.component('industry', Industry);
    Vue.component('region', Region);
    Vue.component('sort', Sort);
    Vue.component('phone', Phone);
    Vue.component('tags', Tags);
    Vue.component('labels', Labels);
    Vue.component('customPagination', customPagination);
    Vue.component('clickSelect', ClickSelect);
    Vue.component('generalSelect', generalSelect);
    Vue.component('generalItem', generalItem);
    Vue.component('awaitTips', awaitTips);
    Vue.component('selectedWrap', selectedWrap);
    Vue.component(inputNumber.name, inputNumber);
    Vue.component(formItem.name, formItem);
    Vue.component(step.name, step);
  }
};

function check(position, cb) {
  if (position > 100) {
    cb(true);
  } else {
    cb(false);
  }
}

function onScroll(ev, cb) {
  let scrollPosition = 0;

  scrollPosition = window.scrollY;
  if (!ticking) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => {
        check(scrollPosition, cb);
        ticking = false;
      });
    } else {
      window.setTimeout(() => {
        check(scrollPosition, cb);
        ticking = false;
      });
    }

    ticking = true;
  }
}



// WEBPACK FOOTER //
// ./src/common/gemPlugin.js